import type { AlertButton, AlertOptions } from "react-native";

// Browser dialogs provide keyboard/focus handling. Never silently execute a
// destructive callback: multiple actions require an explicit choice.
export const Alert = {
  alert(title: string, message?: string, buttons?: AlertButton[], options?: AlertOptions) {
    const content = [title, message].filter(Boolean).join("\n\n");
    if (!buttons?.length) { window.alert(content); return; }
    if (buttons.length === 1) { window.alert(content); buttons[0].onPress?.(); return; }
    const actions = buttons.filter((button) => button.style !== "cancel");
    const cancel = buttons.find((button) => button.style === "cancel");
    if (actions.length === 1) {
      if (window.confirm(`${content}\n\n${actions[0].text ?? "Continuer"} ?`)) actions[0].onPress?.();
      else if (cancel) cancel.onPress?.();
      else options?.onDismiss?.();
      return;
    }
    const answer = window.prompt(`${content}\n\n${actions.map((button, index) => `${index + 1}. ${button.text}`).join("\n")}\nChoisis le numéro de l’action, ou Annuler.`);
    const choice = answer?.trim();
    const action = actions.find((_button, index) => choice === String(index + 1));
    if (action) action.onPress?.();
    else if (cancel) cancel.onPress?.();
    else options?.onDismiss?.();
  },
};
